'use client';

import type {
  Category,
  SubCategoriesEntity,
} from '@eliadmin/core/src/api/slugs/types/slug-detail-types';
import {
  CategoryCard,
  CategoryCardImage,
  CategoryCardName,
  CategoryCardArrow,
  CategoryCardDescription,
} from '@eliadmin/core/src/components/categories/category-card';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

// override: all subcategories are always visible (no "show more"), 2 per row on mobile
export const SubcategoriesCards = ({ category: categoryProp }: { category: Category }) => {
  const templateSettings = useGlobalStore(s => s.templateSettings);

  const getCardContent = (category: SubCategoriesEntity) => {
    return (
      <>
        <div className="flex w-full flex-shrink items-center justify-between gap-2">
          {templateSettings.category?.category_card_image?.enabled &&
            category.image &&
            !Array.isArray(category.image) && (
              <CategoryCardImage
                url={category.image?.url ?? '/images/placeholder.png'}
                alt={category.image.custom_title || category.image.name || category.name}
              />
            )}
          <CategoryCardName className="line-clamp-3 flex-shrink">{category.name}</CategoryCardName>
          <CategoryCardArrow />
        </div>
        {templateSettings.category?.category_card_description?.enabled &&
          !!category.short_description && (
            <CategoryCardDescription>{category.short_description}</CategoryCardDescription>
          )}
      </>
    );
  };

  if (!categoryProp.sub_categories?.length) return null;

  return (
    <>
      <div className={cn('hidden gap-4 overflow-hidden px-4 lg:grid lg:grid-cols-4')}>
        {categoryProp.sub_categories.map(category => (
          <CategoryCard
            key={category.id}
            href={category.slug ?? undefined}
            className={{ content: 'justify-between gap-2' }}
          >
            {!!templateSettings.category?.category_card_image?.enabled &&
              category.image &&
              !Array.isArray(category.image) && (
                <CategoryCardImage
                  url={category.image?.url ?? '/images/placeholder.png'}
                  alt={category.image.custom_title || category.image.name || category.name}
                />
              )}
            <CategoryCardName className="line-clamp-3 flex-shrink">{category.name}</CategoryCardName>
            <CategoryCardArrow />
          </CategoryCard>
        ))}
      </div>
      <div className={cn('grid grid-cols-2 gap-3 overflow-hidden px-4 md:grid-cols-3 md:gap-4 lg:hidden')}>
        {categoryProp.sub_categories.map(category => (
          <CategoryCard
            key={category.id}
            href={category.slug ?? undefined}
            className={{
              root: 'h-auto',
              content: 'flex-col items-center justify-center gap-2',
            }}
          >
            {getCardContent(category)}
          </CategoryCard>
        ))}
      </div>
    </>
  );
};
